// src/components/DevelopmentModal.js
import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Button,
  useDisclosure,
  Image,
  SimpleGrid,
  Box
} from "@chakra-ui/react";

const DevelopmentModal = ({ images }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  if (!images || images.length === 0) {
    return null;
  }

  return (
    <>
      <Button
        onClick={onOpen}
        mt={2}
        fontSize="sm"
        borderWidth="1px"
        borderColor="gray.400"
        variant="outline"
      >
        Se utviklingsprosess
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} scrollBehavior="inside" size="xl">
  <ModalOverlay bg="rgba(4, 31, 20, 0.78)" backdropFilter="blur(4px)" />
  <ModalContent bg="rgba(173, 204, 191, 0.77)" maxW="90vw" maxH="90vh">
    <ModalHeader>Utviklingsprosess</ModalHeader>
    <ModalCloseButton />
    <ModalBody overflow="auto">
      <Box p={4}>
        <SimpleGrid
          columns={{
            base: Math.min(images.length, 1),
            sm: Math.min(images.length, 2),
            md: Math.min(images.length, 3),
          }}
          spacing={4}
        >
          {images.map((item, idx) => {
            // Bilde vs video-sjekk
            if (typeof item === "string" && item.toLowerCase().endsWith(".mp4")) {
              return (
                <Box key={idx} as="video" controls width="100%" maxHeight="400px">
                  <source src={item} type="video/mp4" />
                </Box>
              );
            }
            return (
              <Image
                key={idx}
                src={item}
                alt={`Utviklingsbilde ${idx}`}
                objectFit="cover"
                width="100%"
                maxHeight="400px"
              />
            );
          })}
        </SimpleGrid>
      </Box>
    </ModalBody>
  </ModalContent>
</Modal>
    </>
  );
};

export default DevelopmentModal;